export const getAdvancedSearchQueriesInitialState = () => ({
    cq: '',
    cqWasSet: false,
    aq: '',
    aqWasSet: false,
    lq: '',
    lqWasSet: false,
    dq: '',
    dqWasSet: false,
    defaultFilters: {
        cq: '',
        aq: '',
        lq: '',
        dq: '',
    },
});
